import es from './es-AR';
import en from './en-US';

const languages = {
    ...es,
    ...en
}
export default languages;